var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('CircleCheck',{staticClass:"text-success",attrs:{"size":_vm.size}}):_c('CircleX',{staticClass:"text-danger",attrs:{"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }